/**
 * 按移动距离占完整翻页行程的比例计算动画时长。
 * @param distance 本次折页点移动距离（页面坐标 px）
 * @param fullFlipDistance 完整翻过一页时的参考行程，通常为 2×pageWidth
 * @param totalDuration 完整翻页总时长（ms），即 BookConstants.FLIPPING_TIME
 */
export function calculateFlipAnimationDuration(
  distance: number,
  fullFlipDistance: number,
  totalDuration: number,
  quick = false
): number {
  const duration = (distance / fullFlipDistance) * totalDuration;
  return quick ? Math.min(duration, 120) : duration;
}
